module.exports = __webpack_public_path__ + "img/bell-ringing.d1413b12.svg";